import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { useState, useLayoutEffect } from 'react';

import { setBackgroundAnimationUrl } from '../ControlsBackground';
import default_album_art from '../images/media/default_album_art.png';

import { useDevice } from '../../../store/devices/useDevices.ts';
import { useImage } from '../../../store/images/useImages.ts';
import { useBaseUrl } from '../../../store/SelectedHomeyStore.hooks.ts';

import { theme } from '../../../theme/theme';

export function MediaArt(props) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isError, setIsError] = useState(false);

  const { device } = useDevice({ deviceId: props.deviceId });

  const deviceImage = device?.images.find((image) => {
    return image.type === 'media' && image.id === 'albumart';
  });

  const { baseUrl } = useBaseUrl();
  const { image } = useImage({ imageId: deviceImage?.imageObj.id });
  const url = image != null ? `${baseUrl}${image.url}?${image.lastUpdated}` : null;

  useLayoutEffect(() => {
    if (url) {
      setIsError(false);
      setIsLoaded(false);
      setBackgroundAnimationUrl(url);
    }
  }, [url]);

  return (
    <MediaArtContainer>
      {isError ? (
        <Image
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: isLoaded ? 1 : 0,
          }}
          src={default_album_art}
        />
      ) : (
        <Image
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: isLoaded ? 1 : 0,
          }}
          src={url ?? default_album_art}
          onError={() => {
            setIsError(true);
            setIsLoaded(true);
            setBackgroundAnimationUrl(default_album_art);
          }}
          onLoad={() => {
            setIsLoaded(true);
          }}
        />
      )}
    </MediaArtContainer>
  );
}

const MediaArtContainer = styled.div``;

const Image = styled(motion.img)`
  width: 256px;
  height: 256px;
  border-radius: ${theme.borderRadius.default};
`;
